"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("../");
class BuyerNeedsModel extends _1.BaseModel {
    // TODO Implement in later release.
    // public maxLirr: number;
    // public numberOfUnits: number;
    // public zipCodes: string;
    get salesforceFieldMap() {
        return {
            _id: 'Id',
            acquisitionType: 'McLabs2__Acquisition_Type__c',
            aquisitionType: 'McLabs2__Acquisition_Type__c',
            buildingType: 'McLabs2__Product_Type__c',
            buyerQuality: 'McLabs2__Buyer_Quality__c',
            contactId: 'McLabs2__Contact__c',
            isActive: 'McLabs2__Active__c',
            market: 'McLabs2__Market__c',
            maxPrice: 'McLabs2__Maximum_Purchase_Price__c',
            maxSquareFootage: 'McLabs2__Maximum_Square_Footage__c',
            minCapRate: 'McLabs2__Minimum_CAP_Rate__c',
            minCashOnCash: 'McLabs2__Minimum_Cash_on_cash__c',
            minIrr: 'McLabs2__Minimum_IRR__c',
            minLirr: 'McLabs2__Minimum_LIRR__c',
            minPrice: 'McLabs2__Minimum_Purchase_Price_Actual__c',
            minSquareFootage: 'McLabs2__Minimum_Purchase_Price__c',
            name: 'Name'
        };
    }
    // deprecated field "aquisitionType" on 5/21/18
    get aquisitionType() {
        return this.acquisitionType;
    }
    set aquisitionType(value) {
        this.acquisitionType = value;
    }
}
BuyerNeedsModel.acquisitionTypes = [
    'Core/Stabilized',
    'Distressed',
    'Single-Tenant, Net-Leased',
    'Value Add'
];
BuyerNeedsModel.buildingTypes = [
    'Hotel',
    'Industrial',
    'Multi-Family',
    'Office',
    'Retail',
    'Self-Storage'
];
BuyerNeedsModel.buyerQualities = [
    '1 Will buy within 6 months',
    '2 Might buy within 6 months',
    '3 Will not buy within 6 months'
];
exports.BuyerNeedsModel = BuyerNeedsModel;
//# sourceMappingURL=buyer-needs.model.js.map